// extracted by mini-css-extract-plugin
export var active = "_2g-b";
export var activeIndicator = "_2g-6";
export var animate = "_2g-a";
export var disabled = "_2g-c";
export var flat = "_2g-1";
export var fullWidth = "_2g-3";
export var lg = "_2g-9";
export var md = "_2g-8";
export var redoButtonTabGroup = "_2g-0";
export var sm = "_2g-7";
export var tabButton = "_2g-4";
export var tabButtonsContainer = "_2g-2";
export var xs = "_2g-5";